import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ChatView } from '@/features/chat/ChatView';
import { HelloView } from '@/features/hello/HelloView';
import { MemoryView } from '@/features/memory/MemoryView';
import { SettingsView } from '@/features/settings/SettingsView';
import { useSettings } from '@/settings/settingsStore';
import { appStore, useAppState } from '@/state/appStore';

export default function App() {
  const app = useAppState();
  const settings = useSettings();
  const location = useLocation();

  useEffect(() => {
    void appStore.init();
  }, []);

  useEffect(() => {
    document.title = settings.companionName ? `${settings.companionName}` : 'Puppy';
  }, [settings.companionName]);

  if (!app.ready) return null;
  const named = !!settings.companionName;

  return (
    <>
      <Routes>
        <Route path="/hello" element={<HelloView />} />
        <Route path="/settings" element={<SettingsView />} />
        <Route path="/memory" element={named ? <MemoryView /> : <Navigate to="/hello" replace />} />
        <Route path="/" element={named ? <ChatView /> : <Navigate to="/hello" replace state={{ from: location.pathname }} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {app.notice && <div className="toast" role="status">{app.notice}</div>}
    </>
  );
}
